module.exports = __webpack_public_path__ + "static/media/linkedin-original.bad4685f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linkedin-original.svg
// module id = 25
// module chunks = 0